<a (click)="openGameRoute(firstGame.tournamentPlayoffId, firstGame.id)" *ngIf="games.length > 0">
  <div class="game-flex" [ngClass]="{single: gameRound === 0 && (!firstGame.competitorTeam.id || !firstGame.team.id)}">
    <div class="game-number">{{ textGameNumber }}</div>
    <div class="game" [ngClass]="{final: isFinal(), closed: isClosed}">
      <div class="content">
        <div class="team" *ngIf="firstGame.team.id">
          <div class="logo">
            <img [src]="firstGame.team.logo.path" *ngIf="firstGame.team.logo.path">
            <div [class]="firstGame.team.getEmptyLogoClass()" *ngIf="!firstGame.team.logo.path"></div>
          </div>
          <div class="name">{{ firstGame.team.name }}</div>
        </div>
        <div class="team gray" *ngIf="!firstGame.team.id">{{ winnerTeam }}</div>
        <div class="information">
          <div class="datetime" *ngIf="lastGame.datetime">{{ lastGame.datetime | date: 'd MMM, HH:mm' }}</div>
          <div class="time" *ngIf="!lastGame.datetime">Дата не назначена</div>
          <div *ngIf="firstGame.sport.isHockey() && lastGame.datetime && lastGame.tournamentCourt" class="court">
            {{ lastGame.tournamentCourt.name }}
          </div>
        </div>
        <div class="team" *ngIf="firstGame.competitorTeam.id">
          <div class="logo">
            <img [src]="firstGame.competitorTeam.logo.path" *ngIf="firstGame.competitorTeam.logo.path">
            <div [class]="firstGame.competitorTeam.getEmptyLogoClass()" *ngIf="!firstGame.competitorTeam.logo.path"></div>
          </div>
          <div class="name">{{ firstGame.competitorTeam.name }}</div>
        </div>
        <div class="team gray" *ngIf="!firstGame.competitorTeam.id">{{ winnerCompetitorTeam }}</div>
      </div>
      <ng-container *ngFor="let game of games">
        <div class="score" *ngIf="game.status === gamesStatuses.closed || game.status === gamesStatuses.in_progress">
          <div class="value" [ngClass]="{highlight: game.isClosed && game.teamWinnerId === firstGame.team.id}">
            {{ game.team.id === firstGame.team.id ? game.teamScore : game.competitorTeamScore }}
          </div>
          <div class="value" [ngClass]="{highlight: game.isClosed && game.teamWinnerId === firstGame.competitorTeam.id}">
            {{ game.competitorTeam.id === firstGame.competitorTeam.id ? game.competitorTeamScore : game.teamScore }}
          </div>
          <div class="score-title" *ngIf="gameWithBullits(game)" mtgTooltip="Победа по Буллитам">Б</div>
        </div>
        <div class="score" *ngIf="game.team.sport.isHockey() && game.scoreByPeriod && game.scoreByPeriod[game.hockeyGameConfig.playoffBullitsPeriod]">
          <div class="value" [ngClass]="{highlight: game.isClosed && isTeamWonByPlayoffBullits(game.team.id, game, game.hockeyGameConfig.playoffBullitsPeriod)}">
            {{ game.team.id === firstGame.team.id ? game.scoreByPeriod[game.hockeyGameConfig.playoffBullitsPeriod][0] : game.scoreByPeriod[game.hockeyGameConfig.playoffBullitsPeriod][1] }}
          </div>
          <div class="value" [ngClass]="{highlight: game.isClosed && isTeamWonByPlayoffBullits(game.competitorTeam.id, game, game.hockeyGameConfig.playoffBullitsPeriod)}">
            {{ game.competitorTeam.id === firstGame.competitorTeam.id ? game.scoreByPeriod[game.hockeyGameConfig.playoffBullitsPeriod][1] : game.scoreByPeriod[game.hockeyGameConfig.playoffBullitsPeriod][0] }}
          </div>
          <div class="score-title" mtgTooltip="Буллиты на победителя серии">ПБ</div>
        </div>

        <div class="score" *ngIf="game.team.sport.isHockey() && game.scoreByPeriod && game.scoreByPeriod[game.hockeyGameConfig.playoffOvertimePeriod] && !game.scoreByPeriod[game.hockeyGameConfig.playoffBullitsPeriod]">
          <div class="value" [ngClass]="{highlight: game.isClosed && isTeamWonByPlayoffBullits(game.team.id, game, game.hockeyGameConfig.playoffOvertimePeriod)}">
            {{ game.team.id === firstGame.team.id ? game.scoreByPeriod[game.hockeyGameConfig.playoffOvertimePeriod][0] : game.scoreByPeriod[game.hockeyGameConfig.playoffOvertimePeriod][1] }}
          </div>
          <div class="value" [ngClass]="{highlight: game.isClosed && isTeamWonByPlayoffBullits(game.competitorTeam.id, game, game.hockeyGameConfig.playoffOvertimePeriod)}">
            {{ game.competitorTeam.id === firstGame.competitorTeam.id ? game.scoreByPeriod[game.hockeyGameConfig.playoffOvertimePeriod][1] : game.scoreByPeriod[game.hockeyGameConfig.playoffOvertimePeriod][0] }}
          </div>
          <div class="score-title" mtgTooltip="Буллиты на победителя серии">ПБ</div>
        </div>
      </ng-container>
    </div>
  </div>
</a>
<div class="game-flex" *ngIf="games.length === 0" [ngClass]="{final: isFinal()}">
  <div class="game-number">{{ textGameNumber }}</div>
  <div class="game">
    <div class="content disable">
      <a href="javascript:;" class="btn btn-link game-form-link" *ngIf="canManage && gameRound === 0 && !isLoserBracketGame" (click)="createGameForm()">Добавить игру</a>
      <ng-container *ngIf="gameRound !== 0 || isLoserBracketGame">
        <div class="team gray">{{ winnerTeam }}</div>
        <div class="information gray">Дата не назначена</div>
        <div class="team gray">{{ winnerCompetitorTeam }}</div>
      </ng-container>
    </div>
  </div>
</div>
